import { stripEmptyTags } from '@gameday/common/functions'
import { sanitizeRichText } from '@gameday/common/functions/richText'
import styled from 'styled-components'

import CustomButton from '../Button'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 80px;
  background: var(--white);
  color: var(--dark-text);
  @media only screen and (max-width: 540px) {
    padding: 30px 20px;
    align-items: flex-start;
  }
`

const Title = styled.h2`
  font-size: 25px;
  font-weight: 700;
  margin: 0 34px 60px;
  @media only screen and (max-width: 540px) {
    margin: 0 0 20px 0;
    font-size: 21px;
  }
`

const Text = styled.div`
  max-width: 820px;
  column-count: 2;
  column-gap: 40px;
  column-width: 280px;
  margin-bottom: 50px;
  p:first-child {
    margin-top: 0;
  }
  p:empty {
    display: none;
  }
  p {
    font-weight: 300;
    line-height: 1.6;
  }
  @media only screen and (max-width: 540px) {
    margin-bottom: 16px;
    p {
      font-size: 12px;
    }
  }
`

const EventInfo = ({ background, color, href, info }) => {
  const cleanText = info && sanitizeRichText(stripEmptyTags(info))

  return (
    <Wrapper>
      <Title>Event Information</Title>
      {
        // eslint-disable-next-line jam3/no-sanitizer-with-danger
        // biome-ignore lint/security/noDangerouslySetInnerHtml: TODO
        info && <Text dangerouslySetInnerHTML={{ __html: cleanText }} />
      }
      {href && (
        <CustomButton background={background} color={color} size="large" href={href} target="_blank">
          Register Now
        </CustomButton>
      )}
    </Wrapper>
  )
}

EventInfo.defaultProps = {
  background: '#A53B32',
  color: '#FFFFFF',
}

export default EventInfo
